// ブラウザは選択済みラジオを再クリックしてもchangeを発火しないため、
// clickイベントで現在値と比較して未選択（null）へ戻す。
export function toggleRadioSelection(target, key, value) {
  if (target[key] === value) target[key] = null;
}
